"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRUCIBLE_CONTRACTS_V_0_1 = void 0;
exports.CRUCIBLE_CONTRACTS_V_0_1 = {
    'RINKEBY': {
        factory: '0xdaaa63bba11cded6d70edc0769e93029df4dde52',
        router: '0x678bf901030558e762f7d96cc0268d6591d3a309',
        staking: '',
    },
    'ETHEREUM': {
        factory: '',
        router: '',
        staking: '',
    },
    'POLYGON': {
        factory: '',
        router: '',
        staking: '',
    },
};
//# sourceMappingURL=Contracts.js.map